import { Component, Input, ViewChild, ElementRef, ApplicationRef } from '@angular/core';
import { ConfigProvider } from '../../providers/config/config';
import { Platform, Nav, PopoverController, ModalController, Events, Content, AlertController } from 'ionic-angular';
import { ScreenPage } from '../../pages/screen/screen';
import { AppAvailability } from '@ionic-native/app-availability';
import { CoLocationsComponent } from '../co-locations/co-locations';
import { coButton } from '../../providers/config/config';
import { PageProvider } from '../../providers/page/page';
import { AppState } from '../../config/state';
import { CoBookScannerPopoverComponent } from '../co-book-scanner-popover/co-book-scanner-popover';
import { CoBibItemProvider } from '../../providers/co-bib-item/co-bib-item';
import { CoPopoverKeyboardComponent } from '../../components/co-popover-keyboard/co-popover-keyboard';

import { CoPatronDetailsPage } from '../../pages/co-patron-details/co-patron-details';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { LoadingController } from 'ionic-angular';
import { PatronProvider } from '../../providers/patron/patron';
import { LoginProvider } from '../../providers/login/login';
import { OpenLibraryProvider } from '../../providers/open-library/open-library';
import { CoCatalogSearchPage } from '../../pages/co-catalog-search/co-catalog-search';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { AnalyticsProvider } from '../../providers/analytics/analytics';
import { LocationsProvider } from '../../providers/locations/locations';
import { CoLocationSelectorPage } from '../../pages/co-location-selector/co-location-selector';


@Component({
  selector: 'co-button',
  templateUrl: 'co-button.html'
})
export class CoButtonComponent {
  @ViewChild('buttonEl') btnEl;
  @Input() buttonParameters: coButton;
  nav: Nav;
  text: string;
  color: string; //
  icon: string;
  outline: boolean;
  full: boolean;
  large: boolean;
  small: boolean;
  block: boolean;
  round: boolean;
  output: any;
  rootPage: any;
  isForApp: boolean;
  pageVariables: any = {locationName: ''}
  buttonText: string;
  innerHtml: string;
  @ViewChild(Content) content: Content;
  @ViewChild('configHtml') buttonHtml: ElementRef;
  constructor(public modalCtrl: ModalController, public patronProvider: PatronProvider, public loading: LoadingController, public appAvailability: AppAvailability, public config: ConfigProvider, public platform: Platform, private pages:PageProvider, private state: AppState, public popoverCtrl: PopoverController, private bib: CoBibItemProvider, private toastAlert: ToastAlertsProvider, private login : LoginProvider, private openLibrary : OpenLibraryProvider, private inAppBrowser: InAppBrowser, private ref : ApplicationRef, private events : Events, private analytics: AnalyticsProvider, private _alert:AlertController, private _locationsProvider: LocationsProvider) {
    this.nav = this.state.nav;
    this.isForApp = this.state.cordovaAvailable;
    if (this.state.branchInformation) {
      // this.state.locationId$.subscribe((locationId) => {
        // console.log("location changed", locationId);
        this.pageVariables.locationName = this.state.branchInformation.name;
      // })
    }
  };
  ngAfterViewInit(){
    // this.templateVariables(this.buttonParameters.text).then(res =>{
    //   console.log(res);
    //   this.buttonText = res;
    // })
    if(this.buttonParameters && this.buttonParameters.block && this.buttonParameters.block.css){
      Object.keys(this.buttonParameters.block.css).forEach((key) => {
        let value = this.buttonParameters.block.css[key];
        // this.btnEl._elementRef.nativeElement.style[key]=value;
        this.btnEl._elementRef.nativeElement.style.setProperty(key, value, 'important');
      });
    }
    if (this.buttonParameters.block.html && this.buttonParameters.block.html !== null){
        this.templateVariables(this.buttonParameters.block.html? this.buttonParameters.block.html : "").then(res=>{
          this.innerHtml = res;
          this.buttonHtml.nativeElement.insertAdjacentHTML('beforeend', res);
        })
    }
  }
  openExternal(appNameIos: string, appNameAndroid: string, info: any) {
    let urlLinkObject = info.deviceUrl

    if (this.platform.is('ios')) {
      // for iOS opening
      let urlLink = urlLinkObject.ios
      if (urlLink[urlLink.length - 1] === "/") {
        urlLink = urlLink.slice(0, -1)
      }
      this.appAvailability.check(`${appNameIos}://`).then(
        (yes) => window.open(`${urlLink}`, '_system'),
        (no) => window.open(info.url)
      )
    } else if (this.platform.is('android')) {
      let urlLink = urlLinkObject.android
      // for Android Opening
      window.open(urlLink, '_system')
    } else {
      // for browser opening
      window.open(info.url, '_system')
    }
  }
  showPatronDetails(barcode){
    if (barcode.length > 0) {
      let loader = this.loading.create({ content: "Retrieving patron info" });
      loader.present();

      this.patronProvider.getFullDetails(barcode).then((res) => {
        if (res && res.id != null) {
          this.openPatronDetailsModal(res);
          loader.dismiss().catch(err=>{});
        } else {
          this.toastAlert.triggerToast('An error occurred, please try again', '');
          // this.createLibraryCardScannerPopover();
        };
      }).catch((err) => {
        console.log('failed to login');
        loader.dismiss().catch(err=>{});
        this.toastAlert.triggerToast('Incorrect Information', '');
      });
    } else {
      this.toastAlert.triggerToast('Please enter information', '');
    }
  }

  openPatronDetailsModal(patron){
    let modal = this.modalCtrl.create(CoPatronDetailsPage, { patron: patron }, {cssClass: 'custom-medium-wide-modal'});
    modal.present();
  }
  async templateVariables(string){
    let words = string.split(' ');
    let outWords = []
    words.forEach(word => {
      if(word.match(/{{(.*?)}}/g) ){
        let match = word.match(/{{(.*?)}}/g)[0].substr(2);
        match = match.substr(0, match.length - 2)
        if (this.pageVariables[match]) word = this.pageVariables[match];
        outWords.push(word);
      } else {
        outWords.push(word);
      }
    });
    return outWords.join(' ');
  }
  clicked(button:coButton) {
	  console.log(`button clicked: ${button.block.type}`);
    switch (button.block.type) {
      case "patronfinder":
      if (this.state.loggedInPatronId){
        let loader = this.loading.create({ content: "Retrieving patron info" });
        loader.present();
        this.login.getCurrent().then(res =>{
          this.patronProvider.getFullDetails(res.barcode).then(patron =>{
            loader.dismiss().catch(err=>{});
            this.openPatronDetailsModal(patron);
          })
        })
      } else {
        if (!this.isForApp) {
          let customClass = 'custom-barcode-scanner-popover'
          let popover = this.popoverCtrl.create(CoPopoverKeyboardComponent, { type: 'login' }, { cssClass: customClass });
          popover.present({
            ev: ''
          });

          popover.onDidDismiss(data => {
            if (data && data.info) {
              this.showPatronDetails(data.info)
            } else {
              // this.nav.pop();
            }
          });

        } else {
          this.login.requireLogin((res) => {
            // console.log(res);
            this.showPatronDetails(res.id);
          }, this);
        }
      }
      break;
      case "scan":
        // // FOR TESTING IN BROWSER WITHOUT SCAN
        // if(this.state.demo){
        //   this.bib.showItemFromBibId('9781891830853', 'simple');
        // } else if (this.buttonParameters.block.settings && this.buttonParameters.block.settings['scanType'] == 'isbn'){
        //   if (this.state.hasNovelist){
        //     this.bib.showItemFromISBN('9781891830853', 'simple').then(bibModal=>{
        //       if (bibModal){
        //         // modal.dismiss().catch(err=>{});
        //       }
        //     });
        //   } else {
        //     this.openLibrary.getBookData('9780544974494').then(item =>{
        //       this.nav.push(CoCatalogSearchPage, {searchTerm: item.title, filterParameters: {searchBy: 'ti', filterBy: []}});
        //     })
        //   }
        // }else{
        //   this.bib.showItemFromBarcode('9781891830853', 'simple').then(bibModal=>{
        //     if(bibModal){
        //       // modal.dismiss().catch(err => { });
        //     }
        //   })
        //   // this.bib.showItemFromISBN(data.info, 'simple');
        // }
        this.analytics.trackEvent('Button Clicked', 'Barcode Scanner');
        let modal = this.modalCtrl.create(CoBookScannerPopoverComponent, { type: 'book', showHeader: true, autoCLose:false, blockInfo: button.block, onDone:(data)=>{
          if (data && data.info) {
            if(this.state.demo){
              return this.bib.showItemFromBibId(data.info, 'recommendations');
            } else if (this.buttonParameters.block.settings && this.buttonParameters.block.settings['scanType'] == 'isbn'){
              if (this.state.hasNovelist){
                return this.bib.showItemFromISBN(data.info, 'simple').then(bibModal=>{
                  if (bibModal){
                    modal.dismiss().catch(err=>{});
                  }
                });
              } else {
                return this.openLibrary.getBookData(data.info).then(item =>{
                  if (modal) {
                      this.nav.push(CoCatalogSearchPage, {searchTerm: item.title, filterParameters: {searchBy: (this.state.searchSource === 'discover' ? 'ti':'title'), filterBy: []}}).then((value) => {
                        modal.dismiss().catch(err => { });
                      });
                  }
                })
              }
            }else{
              return this.bib.showItemFromBarcode(data.info, 'simple').then(bibModal=>{
                if(bibModal){
                  modal.dismiss().catch(err => { });
                }
              })
              // this.bib.showItemFromISBN(data.info, 'simple');
            }
          };
        }}, {cssClass: `loginModalBase`});
        modal.present();
        modal.onDidDismiss(data => {

        });


        break;
      case "externallink":
			console.log(`opening external link: ${button.block.url}`);
      this.analytics.trackEvent('Button Clicked', 'External Link', button.block.url);
        if (this.state.cordovaAvailable) {
          this.inAppBrowser.create(button.block.url, "_system");
        } else {
          window.open(button.block.url, '_system');
        }
        break;
      case "linktoscreen":
        this.config.load(this.state.appId).then(cfg => {
          const screen = cfg.screens.find(screen => screen.name == button.block.name);
          if(screen){
			console.log(`navigating to screen: ${screen.name}`);
            if(screen.title)document.title = screen.title;
            this.nav.push(ScreenPage, { screenData: screen, blockInfo: button.block });
          }
        });
        break;

      case "internallink":
			console.log(`opening internal link: ${button.block.url}`);
      const page = this.pages.getPage(button.block.url);
        // console.log(button.block);
        if(page)this.nav.push(page, {blockInfo: button.block});
        break;

      case "embedlink":
			console.log(`opening embeded link: ${button.block.url}`);
      if (this.state.cordovaAvailable) {
        this.inAppBrowser.create(`${button.block.url}`, "_blank", `location=no,closebuttoncaption=Back,toolbarposition=top,closebuttoncolor=#ffffff,mediaPlaybackRequiresUserAction=yes,toolbarcolor=${(button.block.settings && button.block.settings['appToolbarColor'])? button.block.settings['appToolbarColor'] : '#808080'},footer='yes',footercolor=${(button.block.settings && button.block.settings['appToolbarColor'])? button.block.settings['appToolbarColor'] : '#808080'}`);
      } else {
        window.open(`${button.block.url}`, '_blank');
      }
        //4th case
        // in app browser, hide the url address bar
        break;
      case "locations":
			console.log(`opening location page`);
          this.nav.push(CoLocationsComponent);
        break;
      case "functionButton":
        let running = eval('(' + button.block.settings['toRun'] + ')');
        running();
      break;
      case "changeLocationButton":
          modal = this.modalCtrl.create(CoLocationSelectorPage, {}, { cssClass: 'full-screen-modal', enableBackdropDismiss: false });
          modal.onWillDismiss(() => {
            if (!this.state.locationId) {
              modal.present();
            }
          });
          modal.present();
          this.events.subscribe('locationSelected', (location) => {
            console.log("location set ", location.id);
            this.state.locationId = location.id;
            modal.dismiss().catch(err=>{});
            this.events.publish('refreshConfig');
            this._locationsProvider.getLocation(location.id).then(info => {
              if (info) {
                this.state.branchInformation = info;
                this.pageVariables.locationName = this.state.branchInformation.name;
              }
            });
          });
      break;
      case "homeNavButton":
        // console.log(this.state.currentScreen, button.block.settings['filter']);
        // SAID TO KEEP THIS INCASE WE WANT TO FILTER THE HOME SCREEN
        // this.state.currentScreen.blocks.forEach(s =>{
        //   if (s.type === 'homeNavButton') return;
        //   let item = document.getElementById(s.id);
        //   // console.log(item);
        //   if (button.block.settings['filter'].length === 0) {
        //     if (item) item.classList.remove('display-none');
        //   } else if (button.block.settings['filter'].indexOf(s.id) === -1) {
        //     if (item) item.classList.add('display-none');
        //   } else {
        //     if (item) item.classList.remove('display-none');
        //   }
        // });
        if (!button.block.settings['scrollTo']) {
          this.events.publish('homeScrollToTop');
        } else {
          let el = document.getElementById(button.block.settings['scrollTo']);
          el.scrollIntoView({block: 'center'});
        }
        this.ref.tick();
      break;
      case "home":
			console.log(`opening home page`);
        this.nav.popToRoot();
      break;
      case "staffLogoutButton":
        let alert = this._alert.create({
            title: 'Logout',
            cssClass:'confirm-alert',
            message: 'Do you want to log out?',
            buttons: [
              {
                text: 'Yes',
                cssClass: 'confirm-button-outline',
                handler: () => {
                    this.events.publish('staff:logout');
                }
              },
              {
                text: 'No',
                role: 'cancel',
                cssClass: 'confirm-button',
                handler: () => {
                  return;
                }
              }
            ]
          });
          alert.present();

      break;
      default:
			console.log(`unknown button type: ${button.block.type}`);
        console.log(button)
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/co-button/co-button.ts